// Every player-facing string of the ladder portal. Spec §8.2 verb invariant: the three
// commitments never share a word, and the c-word the spec bans is never shown to a player
// (the unit test greps this file for it, so it is not even written here).
// Partner wording is gender-neutral on purpose ("set the week"), the spec's "his" was an example.
import { courtName } from "@/lib/ladder-portal/courts-board";

export const SET_WEEK = "Set my week";
export const BOOK_IT = "Book it";
export const SCORE_RIGHT = "Score is right";
export const LOOKS_RIGHT = "Looks right";
export const UNDO = "Undo";
export const UNDO_LAST = "Undo last";
export const DONE = "Done";

export const SET_WEEK_N = (n: number) => `${SET_WEEK} ${n}`;
export const SET_PARTNER_WEEK = (p: string) => `Set it for ${p}`;
/** My week: whose hours the grid edits (the partner's when agreed on WhatsApp; they can change them anytime). */
export const HOURS_MINE = "My hours";
export const HOURS_OF = (p: string) => `${p}'s hours`;
export const SET_PARTNER_WEEK_N = (p: string, n: number) => `Set ${p}'s week ${n}`;
export const PARTNER_MODE_HINT = (p: string) => `${p} gets a heads-up and can change these anytime.`;
export const PARTNER_PROPOSAL_DAY = "This day has a live proposal. Decline it from the match first, then change the hours";
export const ASK_PARTNER = (p: string) => `Ask ${p}`;
export const PARTNER_SET = (p: string) => `${p} set the week ✓`;
export const PARTNER_NOT_SET = (p: string) => `${p} hasn't set the week`;
export const PARTNER_NOT_SET_YET = (p: string) => `${p} hasn't set the week yet`;
export const PARTNER_NOT_JOINED = (p: string) => `${p} hasn't joined yet - send them the sign-in link`;
export const SEND_SIGN_IN_LINK = "Send the link";
export const ALSO_FOR_PARTNER = (p: string) => `Also set this for ${p}`;

export const CANT_PLAY_WEEK_Q = "Can't play at all this week?";
export const CANT_PLAY_WEEK_EXPLAIN = (p: string) => `We'll look for a court in a later week and ${p} will be told`;
export const IM_AWAY = "I'm away…";
export const AWAY_TITLE = "When are you away?";
export const AWAY_HINT = "We skip those days for you and tell your partner. Away more than once? Add each trip.";
export const AWAY_SAVE = "Mark me away";
export const AWAY_FROM = "From";
export const AWAY_TO = "To";
export const AWAY_DONE = (from: string, to: string) => `Away ${from} - ${to}. We skipped those days.`;
export const MARK_AWAY_RANGE = (from: string, to: string) => `Mark me away ${from} - ${to}`;
export const YES_SKIP_WEEK = "Yes, skip this week";
export const WEEK_SKIPPED = "Week skipped";
export const PARTNER_SKIP_FAILED = (partner: string) => `Couldn't skip the week for ${partner} - skip it on their week too`;
export const SKIPPING_WEEK_BUTTON = "You're skipping this week";
export const UNDO_SKIP = "Undo skip";
export const UNDO_SKIP_NEEDS_HOURS = "Mark at least one hour first, then undo the skip";
export const SKIPPING_WEEK = (p: string) => `You're skipping this week · ${p} has been told`;

export const PILL_PROPOSED = "Court proposed";
export const PILL_BOOKED = "Booked";
export const PILL_YOU_BOOKED = (them: string) => `You booked it · waiting for ${them}`;
export const PILL_PLAYED = "Played";
export const PILL_NO_COURT = "No court yet";
export const EXPIRES = (when: string) => `expires ${when}`;
export const ALL_FOUR_YES = "all four of you said yes";
export const ONE_TAP = "One tap per pair. Either of you can.";
export const NOT_SURE_ASK = (p: string) => `Not sure? Ask ${p} ›`;
export const WE_TOLD_THEM = (expires: string) => `We've told them. Expires ${expires} if they don't answer.`;
export const BOOKED_IT = "Booked it ✓";
export const WAITING_FOR_YOU = "Waiting for you";
export const WAITING_FOR_THEM = "Waiting";
export const YOURE_SET = (when: string) => `You're set. We'll remind all four of you ${when}.`;
export const ADD_TO_CALENDAR = "Add to calendar";
export const RECORD_RESULT = "Record result";
export const RECORD_RESULT_LINK = "Record result ›";
export const NEEDS_SCORE = "Needs a score";
export const NO_SCORE_YET = (opp: string) => `Your match vs ${opp} has no score yet`;
export const CANT_MAKE_IT = "Can't make it";
export const DECLINE = "Decline";
export const CLUB_MOVES_NAMES = "The club puts this court under your names. Cancel here at least 24h before, or they charge you. George and the club are told.";
export const PAY_LATER_RATE = "Book it in the Jungle app with Pay Later - league rate 480K / 90 min, 320K / hour (center court 552K / 90 min).";
// "Can't play anymore" on a booked match; the wording follows what the club has done with the court
export const CANT_PLAY_ANYMORE = "Can't play anymore";
export const CANCEL_REASON_LABEL = "Reason (optional)";
export const CANCEL_MATCH = "Cancel the match";
export const CANCELLED = "Cancelled";
export const KEEP_MATCH = "Keep the match";
export const CANCEL_SLOT_BACK = "The court goes back to the pool and we look for another time. Your opponents are told.";
export const CANCEL_TOO_LATE_CLUB = "The court can't be released this late. Message Jurgis and he'll sort it with the club.";
export const CANCEL_JUNGLE_FIRST = "Cancel here - George and the club are told. Free until 24h before.";
export const CANCEL_TOO_LATE_FREE = "Too late to cancel for free. Message Jurgis.";
export const CANCEL_ADHOC = "The match goes back to no time and we look for another time. Your opponents are told.";
/** After kick-off with no score: the match did not happen (own booking or no-court time) */
export const DIDNT_PLAY = "We didn't play";
export const YES_DIDNT_PLAY = "Yes, we didn't play";
export const CANCEL_DONE = "Cancelled. We're looking for another time";
export const KEEP_PROPOSAL = "Keep the proposal";
export const YES_DECLINE = "Yes, decline it";
export const PROPOSED_HOUR_Q = (when: string) => `${when} is proposed for your match. Can't make it?`;
export const DECLINE_REASONS = (p: string): Array<{ value: "not_free" | "partner_cant" | "other"; label: string; hint: string | null }> => [
  { value: "not_free", label: "Not actually free", hint: "marks those hours as can't" },
  { value: "partner_cant", label: `${p} can't`, hint: null },
  { value: "other", label: "Other", hint: null },
];
export const SET_MY_WEEK_LINK = "Set my week ›";
export const IS_OFF = (when: string, who: string) => `${when} is off. ${who} couldn't make it. Looking for another court.`;
export const SET_THIS_TIME = "Set this time";
export const THATS_WRONG = "That's wrong";

export const WEEK_SET_LOOKING = "Week set · we're looking for a court";
export const WEEK_SET_UPDATED = (hhmm: string) => `Week set · updated ${hhmm}`;
export const SUGGESTED_FROM_LAST = `Suggested from last week. Check, then ${SET_WEEK}`;
export const NOTHING_MARKED = "Tap a day to mark the hours you can play";
export const CELLS_UNSET = `Looks good? ${SET_WEEK} when you're done`;
export const NO_COURT_FITS_IF = (slot: string, them: string) => `No court fits yet. ${slot} would, if ${them} can`;
export const OVERLAP_NO_COURT = (when: string) => `You all overlap ${when}. No held court, book it yourselves ›`;
export const ALL_PLAYED = "Nothing to schedule. All your matches are played";
export const NO_FIXTURES_YET = (n: number) => `Schedule not out yet. Change any day below only if week ${n} differs from your usual week.`;
export const SET_WEEK_DISABLED_HINT = "Mark at least one hour first, or use \"Can't play at all this week?\"";
export const PAST_WEEK = "This week has passed. Read only";

export const CHANGE_WITH_WORDS = "Describe your week";
export const EVERYTHING_ELSE_CANT = "Everything else: can't";
export const FOLLOWUP_QUESTION = { weekends: "Weekends?", weekdayEvenings: "Weekday evenings?", weekdayMornings: "Weekday mornings?" } as const;
export const FOLLOWUP_SUMMARY = { weekends: "Weekends", weekdayEvenings: "Weekday evenings", weekdayMornings: "Weekday mornings" } as const;
export const FOLLOWUP_YES = "Yes";
export const FOLLOWUP_MAYBE = "Maybe";
export const FOLLOWUP_NO = "No";
export const FOLLOWUP_CHANGE = "change";
export const TEXT_PLACEHOLDER = 'When can you play? e.g. "evenings, not Friday"';
export const FILL_MY_WEEK = "Fill my week";
export const LISTENING = "Listening…";
export const PREVIEW_HINT = "Preview. Nothing is saved until you tap Looks right";
export const PREVIEW_HINT_SKIP = "Preview. Nothing is saved until you tap Looks right or Yes, skip this week";

export const LEGEND_ME = "me";
export const LEGEND_MAYBE = "maybe";
export const LEGEND_CANT = "can't";
export const LEGEND_OTHERS = "Other 3 free";
export const DAY_SHEET_HELP = "Tap the hours you can play. Tap again for maybe. Leave the rest empty.";
export const PARTNER_HASNT_SET_WEEK = (p: string) => `${p} hasn't set this week`;
export const PARTNER_HASNT_JOINED = (p: string) => `${p} hasn't joined yet`;
export const COURT_FITS = (label: string) => `${courtName(label)} fits`;
export const COURTS_FIT = (n: number) => `${n} courts fit`;
export const COURTS_NO_FIT = (n: number) => `${n} court${n === 1 ? "" : "s"}, no fit`;
export const NO_HELD_COURT = "no held court";
export const PROPOSED_TAG = "proposed";
export const OVERLAP_TAG = (range: string) => `overlap ${range}`;

export const QUICK_WHOLE_DAY = "Whole day";
export const QUICK_EVENING = "Evening 17–22";
export const QUICK_CLEAR = "Clear day";
export const ALL_FOUR_TICK = "✓ all four";
export const SAME_FOR = "Same for…";
export const SAME_REST_OF_WEEK = "Rest of week";
export const SAME_WEEKDAYS = "Weekdays";
export const SAME_WEEKEND = "Weekend";
export const SAME_COPIED = (n: number) => `Copied to ${n} day${n === 1 ? "" : "s"}`;
export const SAME_ALREADY = "Those days already match";
export const DIFFERENT_TIME = "Different time?";
export const SCORE_PLAYED_AT = (when: string) => `Played ${when}`;

export const NOT_REGISTERED_TITLE = "This season is for registered players";
export const NOT_REGISTERED_BODY = "Standings and the schedule are open to everyone. Availability and match pages are for pairs in the season.";
export const SEE_STANDINGS = "See standings";
export const REGISTER = "Register";
export const DIVISIONS_SOON = "Divisions announced soon";
export const HISTORY = "History";
export const SHOW_ALL = "Show all";
export const SHOW_LESS = "Show less";
export const NOT_YOUR_MATCH = "This isn't your match";

export const HOME_BOOK_IT = "Book it";
export const HOME_OPEN = "Open";
export const HOME_SET = "Set";
export const HOME_SET_FOR = (p: string) => `Set it for ${p}`;

export const WA_ASK_PARTNER_SLOT = (slot: string, url: string) =>
  `Hey! Our ladder match is proposed for ${slot}. Can you make it? If yes, either of us taps "${BOOK_IT}" here: ${url}`;
export const WA_SIGN_IN_PARTNER = (url: string) =>
  `Hey! Our ladder match schedule runs in the ScoreGlass app now. Can you sign in with this link so we can get a court? ${url}`;
export const WA_NUDGE_PARTNER_WEEK = (weekLabel: string, url: string) =>
  `Hey! Can you set your availability for ${weekLabel}? No court can be proposed for us until you do: ${url}`;

// Install gate (web push, spec v2 §16.3)
export const INSTALL_TITLE = "Put ScoreGlass on your home screen";
export const INSTALL_BODY = "You'll get a ping the moment a court is proposed or booked. No app store, takes ten seconds.";
export const INSTALL_BUTTON = "Install";
export const INSTALL_NOT_NOW = "Not now";
export const INSTALL_IOS_STEPS: readonly string[] = ["Tap the Share button at the bottom of Safari", "Choose \"Add to Home Screen\"", "Tap \"Add\", then open ScoreGlass from your home screen and sign in once more (the app keeps its own login)"];
export const INSTALL_IOS_DONE = "I've added it";
export const INSTALL_OPEN_IN_BROWSER = "Open this link in Safari or Chrome to install the app";
export const INSTALL_COPY_LINK = "Copy link";
export const INSTALL_LINK_COPIED = "Link copied";

// Push permission card + Home row (web push, spec v2 §16.4)
export const PUSH_CARD_TITLE = "Get a ping when a court is proposed or booked";
export const PUSH_CARD_BODY = "One notification per match, nothing else.";
export const PUSH_TURN_ON = "Turn on";
export const PUSH_NOT_NOW = "Not now";
export const PUSH_DENIED = "We'll email you instead";
export const PUSH_ROW_ON = "Notifications on";
export const PUSH_ROW_OFF = "Notifications off · Turn on";
export const PUSH_ROW_BLOCKED = "Notifications blocked - allow them for scoreglass.app in your phone's settings";
export const PUSH_ROW_INSTALL = "Install the app to get notifications";

// usual week (pattern)
export const USUAL_WEEK = "My usual week";
export const USUAL_WEEK_EMPTY = "Set this once. We'll use it every week until you change it.";
export const USUAL_WEEK_HINT = "Tap the hours you can usually play. You can change single weeks later.";
export const USUAL_SAVE = "Save usual week";
export const USUAL_SAVED = "Usual week saved. Weeks you edited by hand keep your edits.";
export const USUAL_SAVED_SUMMARY = (s: string) => `Usual week saved · ${s}`;
export const WEEK_FOLLOWS_USUAL = (n: number) => `Week ${n} follows your usual week`;
/** A week past the copy window with no row yet: it shows the usual week and fills in for real two weeks before it starts. */
export const FROM_YOUR_USUAL_WEEK = "From your usual week";
export const WEEK_FROM_USUAL = (n: number) => `Week ${n}: from your usual week`;
export const FROM_USUAL_HINT = (fillsOn?: string) => `${fillsOn ? `Filled in for you on ${fillsOn}. ` : ""}Tap a day to change just this week.`;
export const WEEK_FOLLOWS_HINT = (n: number) => `Changed a day? The button becomes ${SET_WEEK_N(n)}`;
export const DESCRIBE_INSTEAD = "Describe it instead ›";
export const DESCRIBE_MY_WEEK = "Describe my week ›";
export const FIND_TIME_LINK = "Find a time ›";
export const HOME_SET_USUAL = "Set your usual week";
export const HOME_SET_USUAL_SUB = "once, then every week is filled in for you";

// Find a time (spec v2 §4.2)
export const FIND_TIME = "Find a time";
export const FIND_TIME_TITLE = (opp: string, weekNo: number) => `${FIND_TIME} · vs ${opp} · week ${weekNo}`;
export const WORKS_FOR_ALL = "Works for all four";
export const WORKS_FOR_THREE = "Works for three of you";
export const COPY_FOR_WHATSAPP = "Copy for WhatsApp";
export const COPIED = "Copied";
export const NO_CLUB_COURT = "no club court, book at Jungle";
export const PROPOSE = "Propose";
export const ASK_PLAYER = (p: string) => `Ask ${p}`;
export const HASNT_SAID = (p: string) => `${p} hasn't said`;
export const SAID_MAYBE = (p: string) => `${p} said maybe for part of it`;
export const NOTHING_WORKS_YET = "Nothing works for all four yet. Set your week, or ask the others to set theirs.";
// all four weeks are in and still no overlap: the grid below is the answer, not the court list
export const NOTHING_WORKS_ALL_SET = "No hour works for all four of you. Everyone's week is below: find the closest miss and ask that person, or agree a time on WhatsApp and set it.";
export const WERE_IN = "We're in";
// Who books a no-court time (spec §2): the pair that confirms first.
export const WERE_IN_SUB = "Whoever confirms first books the court at Jungle.";
export const YOUR_PAIR_BOOKS = "Your pair books the court at Jungle";
export const THEY_ARE_BOOKING = (pair: string) => `${pair} are booking the court - tap We're in to say you're playing`;
export const PAIR_BOOKS = (pair: string) => `${pair} book the court at Jungle`;
export const PILL_YOURE_IN = (them: string) => `You're in · waiting for ${them}`;
// The confirm step (13 Oct: a tap from a notification booked a time nobody had checked). Nothing books on one tap.
export const CONFIRM_COURT_TITLE = (court: string) => `Book ${courtName(court)} for your pair?`;
export const CONFIRM_COURT_BODY = "The club holds this court for the league. Once both pairs are in, it's booked and the club moves it to your names.";
export const CONFIRM_OWN_TITLE = "Say you're in?";
export const CONFIRM_OWN_BODY = "If you confirm first, you book the court in the Jungle app (Pay Later, league rate). Open the app and check a court is free then, before you tap.";
export const CONFIRM_OWN_OTHER_BOOKS = (who: string) => `${who} books the court at Jungle. You just say your pair is in.`;
export const BOOKER_LINE = (who: string) => `${who} books the court at Jungle`;
export const YOU_BOOK_LINE = "You book the court at Jungle";
export const DID_YOU_BOOK = "Did you book it? Tap the court once it's done, so the club has it.";
export const WAITING_FOR_BOOKER = (who: string) => `Waiting for ${who} to book the court`;
export const COURT_BOOKED_TOAST = (c: string) => `${courtName(c)} noted. The club sheet gets it within 5 minutes.`;
// Find a time: close misses
export const NO_CLOSE_MISSES = "No close misses either. Agree a time on WhatsApp and set it, or widen your weeks.";
export const MISS_WHY = (name: string, state: "maybe" | "unset" | "cant") => state === "maybe" ? `${name} said maybe` : state === "cant" ? `${name} isn't free` : `${name} hasn't said`;
export const SAID_YES = (name: string) => `${name} said yes`;
export const MARKED_FREE_TOAST = (name: string) => `Marked ${name} free. Now set the time.`;
export const ALL_FOUR_SET = "All four weeks set";
export const YOU_HAVENT_SET_WEEK = (weekNo: number) => `You haven't set week ${weekNo} yet.`;
export const EVERYONES_WEEK = "Everyone's week";
export const SHOW_NEXT_WEEKS = (n: number) => `Show the next weeks (${n} courts)`;
export const HIDE_NEXT_WEEKS = "Hide the next weeks";
export const CONFIRM_OWN_CHECKED = "I checked, a court is free then";
export const CONFIRM_UNDO_HINT = (them: string) => `You can undo until ${them} are in.`;
export const YES_WERE_IN = "Yes, we're in";
export const NOT_NOW = "Not now";
export const UNDO_TAP = "Cancel, we can't make it";
export const UNDO_TAP_DONE = "Taken back. The time is still proposed.";
export const SELF_BOOKED_BOOKED = "You booked the court yourselves.";
export const PICK_ANOTHER_TIME = "Can you make one of these instead?";
export const PICK_ANOTHER_TIME_HINT = "One tap turns this one down and proposes yours. The other pair is told.";
export const OR_JUST_DECLINE = "Or just turn it down";
export const NO_OTHER_TIME = "No other time works for all four of you yet.";
export const AGREED_ENTER_IT = "Already agreed a time? Enter it";
export const CANT_MAKE_IT_LINK = "Can't make it? ›";
export const MORE_TIMES = (n: number) => `${n} more time${n === 1 ? "" : "s"} in Find a time ›`;
export const NO_TIME_YET = "No time yet";
export const WA_ASK_PLAYER_SLOT = (p: string, slot: string, url: string) => `Hi ${p}, everyone else can do ${slot} for our ladder match. Does that work? Mark it here: ${url}`;
/** One line per week: "This week · 12 – 18 Oct: Mon 18:00, Tue 19:30". */
export const WA_FREE_COURTS = (lines: string[]) => `Free courts for our match:\n${lines.join("\n")}\nWhich could you make?`;

// Find a time, before the other weeks are in (season polish spec §8)
export const WEEKS_SET = "Weeks set";
export const WAITING_CARD_TITLE = "We find a court the moment all four weeks are in";
export const WAITING_CARD_SUB = "Each nudge opens WhatsApp with a one-line message and the link to their week.";
export const ROLE_YOU = "You";
export const ROLE_PARTNER = "Your partner";
export const ROLE_OPPONENT = "Opponent";
export const ROLE_PLAYER = "Player";
export const ADMIN_VIEW = "Admin view · not your match. You can ask and mark hours for the four; the pairs book.";
export const WEEK_STATE_SET = "Week set";
export const WEEK_STATE_UNSET = "not set";
export const WEEK_STATE_CANT = "can't play this week";
export const WEEK_STATE_UNLINKED = "hasn't joined yet";
export const NUDGE = "Nudge ›";
export const NUDGE_ARIA = (name: string) => `Nudge ${name}`;
export const NUDGE_NAME = (name: string) => `Nudge ${name} ›`;
export const SEND_LINK_ARIA = (name: string) => `Send the sign-in link to ${name}`;
export const NOT_JOINED_LINE = (name: string) => `${name} ${WEEK_STATE_UNLINKED}`;
export const WEEK_ROWS_ERROR = "Couldn't load who has set their week. Pull to refresh.";
export const AGREED_ALREADY = "Already agreed a time with them?";
export const SET_IT = "Set it ›";
export const COURTS_HELD_ROW = (n: number) => `Club courts · ${n} held this week`;
/** Week headings on Find a time, by distance from the match week: "This week · 12 – 18 Oct". Only offsets 0-2 exist (the horizon). */
export const WEEK_LABELS = ["This week", "Next week", "Week after"] as const;
export const WEEK_HEADING = (offset: number, range: string) => `${WEEK_LABELS[Math.min(Math.max(offset, 0), 2)]} · ${range}`;
/** Suffix after a time that is not in the match week. */
export const PLAYED_IN_WEEK = (n: number) => `played in week ${n}`;
/** "Ramon", "Ramon and Justin", "Ramon, Justin and Nikil" */
export const joinNames = (names: string[]): string =>
  names.length <= 1 ? (names[0] ?? "") : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
export const WAITING_SENTENCE = (names: string[]) => `Waiting for ${joinNames(names)} to set their week`;

// ── Set the time: record a time or court the pairs agreed outside the app ─────────────────────
export const SET_THE_TIME = "Set the time";
export const SET_THE_TIME_HINT = "Agreed with your opponents? Pick a league court, or tell us the time you booked yourselves.";
export const OWN_TIME_PAY_LATER = "Book it in the Jungle Padel app with Pay Later - league rate 480K / 90 min (center court 552K).";
export const CENTER_COURT_TAG = "552K";
/** Set the time: someone in the match said no to these hours (the court stays tappable). */
export const CANT_THEN = (names: string[]) =>
  `${names.length <= 2 ? names.join(" and ") : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`} can't then`;
/** A sub in this one match (admin-recorded). */
export const PLAYS_FOR = (sub: string, out: string, played: boolean) => `${sub} ${played ? "played" : "plays"} for ${out}`;
/** Own booking: which Jungle court they booked (the club prices by court and finds the booking by it). */
export const OWN_COURT_LABEL = "Court you booked";
export const OWN_COURT_PICK = "Pick a court";
export const WE_BOOKED_OWN = "We booked our own time";
export const WE_ALREADY_PLAYED = "We already played";
export const LEAGUE_COURTS = "League courts";
export const COURT_BOOKED = "Booked";
export const COURT_RELEASED = "Released to the club";
export const NO_COURTS_LISTED = "No league courts in these weeks.";
export const BOOK_COURT_Q = (label: string) => `Book ${label}?`;
export const YES_BOOK_IT = "Yes, book it";
export const OWN_TIME_Q = (when: string) => `We play ${when} at Jungle Padel Sanur. Tell the other pair?`;
export const YES_WE_PLAY_THEN = "Yes, we play then";
export const NOT_AGREED = "That's not what we agreed";
export const NOT_AGREED_Q = "Put it back? The court goes back in the pool and the other pair is told.";
export const NOT_AGREED_OWN_Q = "Put it back? The match goes back to no time and the other pair is told.";
export const YES_PUT_BACK = "Yes, put it back";
export const TIME_SET_TOAST = "Time set. The other pair has been told";
export const NOT_AGREED_DONE = "Put back. We look for a court again";
export const YOU_SET_THIS_TIME = "You set this time";
export const CHANGE_IT = "Change it";
export const CHANGE_IT_Q = "Take it back and pick again? The other pair is told.";
export const YES_CHANGE_IT = "Yes, take it back";
export const TOO_LATE_TO_CHANGE = "Too late to change it here - use Can't play anymore below.";

// ── Play early: who can you play, week by week ───────────────────────────────
export const WHO_CAN_YOU_PLAY = (weekNo: number) => `Who can you play in week ${weekNo}?`;
export const COULD_PLAY_INSTEAD = "Could play this week instead";
export const NO_PAIR_FITS = "No other pair fits this week - set next week's hours.";
export const WEEK_PILL_EARLY = (weekNo: number, range: string) => `Week ${weekNo} · early · ${range}`;
export const WHO_LOADING = "Checking who's free…";
export const WHO_ERROR = "Couldn't check who's free. Try again in a moment.";
export const SEE_EVERYONE = "See everyone ›";
export const WHO_WORKS = (times: string, more: number) => `Works: ${times}${more > 0 ? ` +${more} more` : ""}`;
export const WHO_CLOSE = (when: string, name: string, maybe: boolean) => `${when} works if ${name} ${maybe ? "makes it" : "says yes"}`;
export const WHO_UNSET = (names: string[]) => `${names.join(" and ")} ${names.length > 1 ? "haven't" : "hasn't"} set this week`;
export const WHO_NOTHING = "All set, no hour works";
export const WHO_OFF = (names: string[]) => `${names.join(" and ")} ${names.length > 1 ? "are" : "is"} off this week`;
export const WHO_INCOMPLETE = "Waiting for the pair to join";
export const WHO_PROPOSED = (when: string) => `Proposed ${when}`;
export const WHO_BOOKED = (when: string) => `Booked ${when}`;

// ── Mobile declutter (spec 2026-10-15) ───────────────────────────────────────
// My week
export const USUAL_EDIT = "Usual week · Edit ›";
export const COULD_HAPPEN = (weekNo: number) => `Could happen in week ${weekNo}`;
export const SEE_ALL_N = (n: number) => `See all ${n} ›`;
export const ROW_PROPOSE = "Propose ›";
export const ROW_ASK = "Ask ›";
// Schedule
export const NO_TIME_NOTE = (n: number) => `${n} match${n === 1 ? " has" : "es have"} no time yet.`;
export const SET_YOUR_HOURS = "Set your hours ›";
export const NO_TIME_NOTE_TAIL = "and we propose one when all four are free.";
export const NEXT_MATCH = (weekNo: number) => `Next match · Wk ${weekNo}`;
// Standings
export const NO_RESULTS_YET = (range: string) => `No results yet · first matches ${range}`;
export const ZONE_PROMOTED = (n: number) => `↑ Top ${n} promoted`;
export const ZONE_RELEGATED = (n: number) => `↓ Bottom ${n} relegated`;
export const YOU_TAG = "You";
export const FINALS_DAY_LINE = (day: string) => `Finals Day · ${day}`;
// Find a time
export const TIMES_THAT_WORK = "Times that could work";
export const BEST_FIRST = "Best first";
export const BEST = "Best";
export const PROPOSE_BEST = (when: string, court: string | null) => `Propose ${when}${court ? ` · ${courtName(court)}` : ""}`;
export const PROPOSE_BEST_SUB = (opp: string) => `${opp} get asked to say yes`;
export const SET_LABEL = "Set:";
export const WEEK_PILL_SHORT = (weekNo: number, range: string) => `Wk ${weekNo} · ${range}`;
export const WEEK_PILL_OFF = (label: string, names: string[]) => `${label} · ${names.join(", ")} off`;
// "You already play that day" (26 Oct): a day one of the four has a match on is marked everywhere a time is picked, never blocked.
const playVerb = (who: string) => (who === YOU_TAG || who.includes("&") ? "play" : "plays");
export const BUSY_DAY_NOTE = (who: string, time: string, proposed: boolean) => proposed ? `${who} might play at ${time} (proposed)` : `${who} ${playVerb(who)} at ${time}`;
export const BUSY_ROW_NOTE = (who: string, time: string, proposed: boolean) => proposed ? `${who} might play at ${time} that day (proposed)` : `${who} already ${playVerb(who)} at ${time} that day`;
export const ALL_BUSY_HINT = "The only times that work are on days one of you already plays. You can still propose one.";
